export default [
    {
        path: '/logistica/mantenimiento/chofer',
        name: 'logistica-mantenimiento-chofer',
        component: () => import('@/views/pages/logistica/matenimiento/Chofer.vue'),
        meta: {
            title: 'i18n:logistica.mantenimiento.chofer.title',
            resource: 'Logistica',
            action: 'ver-logistica-mantenimiento-chofer',
            pageTitle: 'Mantenimiento de Chofer',
            breadcrumb: [
                {
                    text: 'logistica.mantenimiento.chofer.title',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/logistica/mantenimiento/vehiculo',
        name: 'logistica-mantenimiento-vehiculo',
        component: () => import('@/views/pages/logistica/matenimiento/Vehiculo.vue'),
        meta: {
            title: 'i18n:logistica.mantenimiento.vehiculo.title',
            resource: 'Logistica',
            action: 'ver-logistica-mantenimiento-vehiculo',
            pageTitle: 'Mantenimiento de Vehiculo',
            breadcrumb: [
                {
                    text: 'logistica.mantenimiento.vehiculo.title',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/logistica/mantenimiento/infraccion',
        name: 'logistica-mantenimiento-infraccion',
        component: () => import('@/views/pages/logistica/matenimiento/Infraccion.vue'),
        meta: {
            title: 'i18n:logistica.mantenimiento.infraccion.title',
            resource: 'Logistica',
            action: 'ver-logistica-mantenimiento-infraccion',
            pageTitle: 'Mantenimiento de Infraccion',
            breadcrumb: [
                {
                    text: 'logistica.mantenimiento.infraccion.title',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/logistica/mantenimiento/lista-negra',
        name: 'logistica-mantenimiento-lista-negra',
        component: () => import('@/views/pages/logistica/matenimiento/ListaNegra.vue'),
        meta: {
            title: 'i18n:logistica.mantenimiento.listaNegra.title',
            resource: 'Logistica',
            action: 'ver-logistica-mantenimiento-lista-negra',
            pageTitle: 'Mantenimiento de Lista Negra',
            breadcrumb: [
                {
                    text: 'logistica.mantenimiento.listaNegra.title',
                    active: true,
                },
            ],
        },
    },
]
